import { LifeBuoy } from "lucide-react";
import { defineModuleUi } from "@vixio/data";
import { lazyPage } from "@vixio/ui";
import "./api";
import { HelpTopbar } from "./HelpTopbar";

export * from "./api";

// Telas carregadas sob demanda: cada uma vira um arquivo à parte no build.
const HelpCenterPage = lazyPage(() => import("./HelpCenterPage"), "HelpCenterPage");
export { HelpTopbar };

export default defineModuleUi({
  key: "help",
  title: "Ajuda",
  domain: "platform",
  icon: LifeBuoy,
  menu: [{ path: "/configuracoes/ajuda", label: "Central de ajuda", minRole: "viewer", icon: LifeBuoy, order: 90, keywords: "ajuda tópico tour glossário faq dúvida" }],
  routes: [{ path: "/configuracoes/ajuda", element: <HelpCenterPage />, minRole: "viewer" }],
  topbar: HelpTopbar,
});
